/*
  First Impressions V2.
  Standalone data, rendering, and player. Do not merge with First
  Impressions V1 or Regirl Refresh.
*/
(function () {
  "use strict";

  if (window.__REGIRL_FIRST_IMPRESSIONS_V2_LOADED__) return;
  window.__REGIRL_FIRST_IMPRESSIONS_V2_LOADED__ = true;

  var activeIndex = 0;
  var activeTrigger = null;
  var activeProductName = "";
  var activeVideos = [];
  var products = [
    {
      name: "Hot Minute",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/glam.png?v=1760542839", video: "https://cdn.shopify.com/videos/c/o/v/85b6f081087f40f5a8e85d6562dacb48.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Hot_Minute_Illustration.png?v=1789568774", video: "https://cdn.shopify.com/videos/c/o/v/b67f34cdf3bd47449cdbfedacccde15f.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/hot_minute_impressions_still.png?v=1789557903", video: "https://cdn.shopify.com/videos/c/o/v/d2eb26cb32d6452c8501720d3d04981d.mov" }
      ]
    },
    {
      name: "Dolly Star",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/glam.png?v=1760542839", video: "https://cdn.shopify.com/videos/c/o/v/1d188a28599c4ffc8422c01b4687e850.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Dolly_Star_Illustration.png?v=1789565245", video: "https://cdn.shopify.com/videos/c/o/v/97ee5f99d2174026ab9fcf607e0d4c77.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/dolly_star_impressions_still.png?v=1789557919", video: "https://cdn.shopify.com/videos/c/o/v/d920840c543e4f8388a1c7cfca621fa0.mov" }
      ]
    },
    {
      name: "Mother",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/bob_era_unboxing.png?v=1760537250", video: "https://cdn.shopify.com/videos/c/o/v/d6836d537c6549a8a4193f9c33b1bb0b.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Mother_Illustration.png?v=1789565319", video: "https://cdn.shopify.com/videos/c/o/v/18489ca6840649e1807cc5eea7b7f228.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/mother_impressions_still.png?v=1789557849", video: "https://cdn.shopify.com/videos/c/o/v/467ae9aa90c64608982841654ee6fc30.mov" }
      ]
    },
    {
      name: "Soft Siren",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/glam.png?v=1760542839", video: "https://cdn.shopify.com/videos/c/o/v/4c69e873e2a542e99a619b9ac7d58e83.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Soft_Siren_Illustration.png?v=1789565256", video: "https://cdn.shopify.com/videos/c/o/v/058346fe06d44b70a17ba83b6ba53c08.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/soft_siren_impressions_still.png?v=1789557454", video: "https://cdn.shopify.com/videos/c/o/v/dd853030aaa64d05bd1098c5cfdb0719.mov" }
      ]
    },
    {
      name: "Soft Girl",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/bob_era_unboxing.png?v=1760537250", video: "https://cdn.shopify.com/videos/c/o/v/59dbe6eb33bd4ffe9d25bbb979acfde0.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Soft_Girl_Illustration.png?v=1789565346", video: "https://cdn.shopify.com/videos/c/o/v/0add33613cdb494fbbba70418b979f19.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/15_29d9c9b5-a01a-4ad5-828f-c35405a34c70.png?v=1760529234", video: "https://cdn.shopify.com/videos/c/o/v/696036ca033c4439833cc4dfbc239dab.mov" }
      ]
    },
    {
      name: "Soft Madame",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/glam.png?v=1760542839", video: "https://cdn.shopify.com/videos/c/o/v/713dd9dc32f04ef2b966489548e7fb3f.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Soft_Madame_Illustration.png?v=1789565276", video: "https://cdn.shopify.com/videos/c/o/v/e326f8f7785e47b58d840696cc1faa49.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/first_impression_thubnails11.png?v=1760612675", video: "https://cdn.shopify.com/videos/c/o/v/dec9645b57f64b38bae847e4c715a3c5.mov" }
      ]
    },
    {
      name: "Spicy Icon",
      videos: [
        { label: "Straight out of the box", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/glam.png?v=1760542839", video: "https://cdn.shopify.com/videos/c/o/v/2d2eb07047db4e1b9d4194f4a3885316.mp4" },
        { label: "How to wear", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/Spicy_Icon_Illustration.png?v=1789565263", video: "https://cdn.shopify.com/videos/c/o/v/d5a3ac451f2546bca40fcfa2310778be.mp4" },
        { label: "In action", poster: "https://cdn.shopify.com/s/files/1/0648/3224/1887/files/on_you_1.png?v=1760529408", video: "https://cdn.shopify.com/videos/c/o/v/0937013331fc4a309ada8d68f14c5018.mov" }
      ]
    }
  ];

  /* Match the live Hair Maintenance collection order. The source objects
     remain grouped by the original First Impressions production order so
     their video and poster pairings stay easy to maintain. */
  var displayOrder = [1, 6, 5, 0, 2, 3, 4];

  function ensurePlayer() {
    var player = document.getElementById("fiv2-player");
    if (player) return player;

    document.body.insertAdjacentHTML("beforeend",
      '<section class="fiv2-player" id="fiv2-player" role="dialog" aria-modal="true" aria-label="First Impressions video player">' +
        '<div class="fiv2-player__frame">' +
          '<video class="fiv2-player__video" playsinline controls preload="auto"></video>' +
          '<div class="fiv2-player__header"><div class="fiv2-player__controls">' +
            '<button class="fiv2-player__control fiv2-player__mute" type="button" aria-label="Unmute video">&#128263;</button>' +
            '<button class="fiv2-player__control fiv2-player__close" type="button" aria-label="Close video">&#215;</button>' +
          '</div></div>' +
          '<button class="fiv2-player__nav fiv2-player__nav--previous" type="button" aria-label="Previous video">&#8592;</button>' +
          '<button class="fiv2-player__nav fiv2-player__nav--next" type="button" aria-label="Next video">&#8594;</button>' +
        '</div>' +
      '</section>'
    );

    player = document.getElementById("fiv2-player");
    player.querySelector(".fiv2-player__close").addEventListener("click", closePlayer);
    player.querySelector(".fiv2-player__mute").addEventListener("click", function () {
      var video = player.querySelector(".fiv2-player__video");
      video.muted = !video.muted;
      updateMuteControl(video, player);
    });
    player.querySelector(".fiv2-player__nav--previous").addEventListener("click", function () { showVideo(activeIndex - 1); });
    player.querySelector(".fiv2-player__nav--next").addEventListener("click", function () { showVideo(activeIndex + 1); });
    player.addEventListener("click", function (event) {
      if (event.target === player) closePlayer();
    });
    document.addEventListener("keydown", function (event) {
      if (!player.classList.contains("is-open")) return;
      if (event.key === "Escape") closePlayer();
      if (event.key === "ArrowLeft") showVideo(activeIndex - 1);
      if (event.key === "ArrowRight") showVideo(activeIndex + 1);
    });
    return player;
  }

  function updateMuteControl(video, player) {
    var mute = player.querySelector(".fiv2-player__mute");
    mute.innerHTML = video.muted ? "&#128263;" : "&#128266;";
    mute.setAttribute("aria-label", video.muted ? "Unmute video" : "Mute video");
  }

  function showVideo(index) {
    if (index < 0 || index >= activeVideos.length) return;
    activeIndex = index;
    var item = activeVideos[activeIndex];
    var player = ensurePlayer();
    var video = player.querySelector(".fiv2-player__video");

    video.pause();
    video.src = item.video;
    video.poster = item.poster;
    video.muted = true;
    video.load();
    player.setAttribute("aria-label", activeProductName + " First Impressions video player");
    updateMuteControl(video, player);
    player.querySelector(".fiv2-player__nav--previous").hidden = activeIndex === 0;
    player.querySelector(".fiv2-player__nav--next").hidden = activeIndex === activeVideos.length - 1;
    player.classList.add("is-open");
    video.play().catch(function () {
      /* Native controls remain available if playback is blocked. */
    });
  }

  function openPlayer(productIndex, trigger) {
    activeTrigger = trigger;
    activeVideos = [products[productIndex].videos[1]];
    activeProductName = products[productIndex].name;
    document.documentElement.classList.add("fiv2-player-open");
    document.body.classList.add("fiv2-player-open");
    showVideo(0);
  }

  function closePlayer() {
    var player = document.getElementById("fiv2-player");
    if (!player || !player.classList.contains("is-open")) return;
    var video = player.querySelector(".fiv2-player__video");
    video.pause();
    video.removeAttribute("src");
    video.load();
    player.classList.remove("is-open");
    document.documentElement.classList.remove("fiv2-player-open");
    document.body.classList.remove("fiv2-player-open");
    if (activeTrigger) activeTrigger.focus();
  }

  function makeVideoCard(item, productIndex, productName) {
    var loading = productIndex === 0 ? "eager" : "lazy";
    return '<button class="fiv2-video-row" type="button" data-fiv2-product-index="' + productIndex + '" aria-label="Play how to wear ' + productName + '">' +
      '<img class="fiv2-video-row__poster" src="' + item.poster + '" alt="How to wear ' + productName + '" loading="' + loading + '" decoding="async">' +
      '<span class="fiv2-video-row__scrim" aria-hidden="true"></span>' +
      '<span class="fiv2-video-row__play" aria-hidden="true">&#9654;</span>' +
      '<span class="fiv2-video-row__context" aria-hidden="true">' + productName + '</span>' +
    '</button>';
  }

  function render() {
    var list = document.getElementById("fiv2-video-list");
    if (!list) return;
    list.innerHTML = displayOrder.map(function (productIndex) {
      var product = products[productIndex];
      return makeVideoCard(product.videos[1], productIndex, product.name);
    }).join("");

    list.querySelectorAll(".fiv2-video-row__poster").forEach(function (image) {
      image.addEventListener("error", function () {
        var card = image.closest(".fiv2-video-row");
        var productName = card ? products[parseInt(card.getAttribute("data-fiv2-product-index"), 10)].name : "Regirl";
        image.insertAdjacentHTML("afterend", '<span class="fiv2-video-row__fallback" aria-hidden="true">' + productName + '</span>');
        image.remove();
      }, { once: true });
    });
    list.querySelectorAll(".fiv2-video-row").forEach(function (row) {
      row.addEventListener("click", function () {
        openPlayer(
          parseInt(row.getAttribute("data-fiv2-product-index"), 10),
          row
        );
      });
    });
  }

  window.regirlFirstImpressionsV2Boot = function () {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", render, { once: true });
    } else {
      render();
    }
  };
}());
